<template>
    <div class="flex flex-column xl:flex-row lg:flex-row md:flex-row px-3 py-2">
        <div class="flex flex-row align-items-center">
            <!-- <MultiSelect :modelValue="selectedColumns" :options="columns" optionLabel="header" @update:modelValue="onToggle" display="chip" placeholder="Колонки" size="small" class="border-round-lg border-2" /> -->
            <Button label="Обновить" icon="pi pi-sync" size="small" @click="LoadSenders" class="border-round-lg border-0 ml-2" severity="info" outlined/>
            <Button label="Сбросить" icon="pi pi-filter" size="small" @click="resetFilter" class="border-round-lg border-0 ml-2" severity="info" outlined/>
        </div>
    </div>

    <DataTable
        v-if="list"
        :value="list"
        lazy
        paginator
        :rows="20"
        v-model:filters="filters"
        ref="dt"
        dataKey="id"
        :totalRecords="totalRecords"
        :loading="loading"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        filterDisplay="menu"
        :globalFilterFields="[
            'id',
            'user_id',
            'status',
            'email',
            'first_name',
            'last_name',
            'phone',
            'kyc.type',
            'kyc.status',
            'kyc.doc_id',
            'kyc.last_message'
        ]"
        :rowsPerPageOptions="[5, 10, 20, 50, 100, 200, 300, 400, 500]"
    >

        <!-- ID отправителя -->
        <Column field="id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true" :exportable="false">
            <template #header>
                <span class="text-xs">ID</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.id">
                    <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.id }}
                        </span>
                    </span>...
                    <Button
                        icon="pi pi-copy text-xs"
                        @click="copy(data.id)"
                        size="small"
                        class="border-round-md border-round-lg border-0"
                        severity="info"
                        outlined
                    />
                </div>
            </template>
        </Column>

        <!-- Пользователь -->
        <Column field="user_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Пользователь</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-1 align-items-center" v-if="data.user_id">
                    <span class="text-xs flex my-auto overflow-hidden" style="max-width:4em">
                        <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                            {{ data.user_id }}
                        </span>
                    </span>...
                    <Button
                        icon="pi pi-copy text-xs"
                        @click="copy(data.user_id)"
                        size="small"
                        class="border-round-md border-round-lg border-0"
                        severity="info"
                        outlined
                    />
                    <Button
                        icon="pi pi-external-link text-xs"
                        @click="detail_page(data.user_id, 'user', true)"
                        size="small"
                        class="border-round-md border-round-lg border-0"
                        severity="info"
                        outlined
                    />
                </div>
            </template>
        </Column>

        <!-- Статус отправителя -->
        <Column field="status" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">Статус</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown
                    v-model="filterModel.value"
                    @change="filterCallback()"
                    :options="senderStatusOptions"
                    optionLabel="label"
                    optionValue="value"
                    class="p-column-filter w-12rem"
                    placeholder="Все"
                    :showClear="true"
                >
                    <template #option="{ option }">
                        <span class="text-xs">{{ option.label }}</span>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <div class="flex align-items-center gap-2">
                    <Tag :severity="getSeverityByStatus(data.status)" :value="getStatusLabel(data.status)" class="text-xs" />
                    <Button
                        icon="pi pi-pencil"
                        size="small"
                        class="p-button-text text-xs"
                        :title="'Изменить статус отправителя'"
                        @click="openStatusDialog(data)"
                        severity="info" outlined
                    />
                </div>
            </template>
        </Column>

        <!-- Email -->
        <Column field="email" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Email</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.email">
                    <span class="text-xs" v-if="data.email">{{ data.email }}</span>
                    <Button
                        icon="pi pi-copy text-xs"
                        @click="copy(data.email)"
                        size="small"
                        class="border-round-md border-round-lg border-0"
                        severity="info"
                        outlined
                    />
                </div>
            </template>
        </Column>

        <!-- Имя -->
        <Column field="first_name" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Имя</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="data.first_name">{{ data.first_name }}</span>
            </template>
        </Column>

        <!-- Фамилия -->
        <Column field="last_name" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Фамилия</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="data.last_name">{{ data.last_name }}</span>
            </template>
        </Column>

        <!-- Телефон -->
        <Column field="phone" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">Телефон</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.phone">
                    <span class="text-xs" v-if="data.phone">{{ data.phone }}</span>
                    <Button
                        icon="pi pi-copy text-xs"
                        @click="copy(data.phone)"
                        size="small"
                        class="border-round-md border-round-lg border-0"
                        severity="info"
                        outlined
                    />
                </div>
            </template>
        </Column>

        <!-- Файлы -->
        <Column field="files" :showFilterMatchModes="false" :showClearButton="false">
            <template #header>
                <span class="text-xs">Файлы</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.files">
                    <span v-for="f of data.files" :key="f" class="text-sm flex flex-row">
                        <Button icon="pi pi-file" @click="openFilePopup(f)" size="small" severity="info" outlined />
                    </span>
                </div>
            </template>
        </Column>

        <!-- Действия: проверка KYC -->
        <Column field="actions" :exportable="false">
            <template #header>
                <span class="text-xs">KYC</span>
            </template>
            <template #body="{ data }">
                <Button
                    label="Проверить"
                    size="small"
                    class="border-round-md text-sm"
                    severity="info" outlined
                    :loading="kycLoadingId === data.id"
                    @click="checkKyc(data.id)"
                />
            </template>
        </Column>

        <!-- KYC: тип -->
        <!-- <Column field="kyc.vendor" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">KYC тип</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-10rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="data.kyc && data.kyc.vendor">{{ data.kyc.vendor }}</span>
            </template>
        </Column> -->

        <!-- KYC: статус -->
        <Column field="kyc.status" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">KYC статус</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-10rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <Tag v-if="data.kyc && data.kyc.status" 
                    :severity="getSeverityByStatus(data.kyc.status)" :value="data.kyc.status" class="text-xs" />
            </template>
        </Column>

        <!-- KYC: doc_id -->
        <Column field="kyc.doc_id" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">KYC doc_id</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-12rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <span class="text-xs" v-if="data.kyc && data.kyc.doc_id">{{ data.kyc.doc_id }}</span>
            </template>
        </Column>

        <!-- KYC: passport -->
        <Column field="kyc.passport" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">KYC passport</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-16rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.kyc && data.kyc.passport">
                    <Button
                        label="Открыть"
                        size="small"
                        class="border-round-md"
                        severity="info"
                        outlined
                        @click="openKycDialog('passport', data.kyc.passport)"
                    />
                </div>
            </template>
        </Column>

        <!-- KYC: metadata -->
        <Column field="kyc.metadata" filterMatchMode="contains" :showFilterMatchModes="false" :showClearButton="true">
            <template #header>
                <span class="text-xs">KYC metadata</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <InputText
                    type="text"
                    v-model="filterModel.value"
                    @keydown.enter="filterCallback()"
                    class="p-column-filter w-16rem"
                    placeholder="Найти"
                />
            </template>
            <template #body="{ data }">
                <div class="flex flex-row gap-2 align-items-center" v-if="data.kyc && data.kyc.metadata">
                    <Button
                        label="Открыть"
                        size="small"
                        class="border-round-md"
                        severity="info"
                        outlined
                        @click="openKycDialog('metadata', data.kyc.metadata)"
                    />
                </div>
            </template>
        </Column>

        <!-- KYC: создано -->
        <Column
            field="kyc.created_at"
            sortable
            filterField="kyc.created_at"
            dataType="date"
            :showFilterMatchModes="false"
            :showFilterOperator="false"
            :showClearButton="true"
        >
            <template #header>
                <span class="text-xs">KYC создано</span>
            </template>
            <template #filter="{ filterModel }">
                <Calendar
                    v-model="filterModel.value"
                    dateFormat="dd.mm.yy"
                    placeholder="dd.mm.yy"
                    mask="99.99.9999"
                />
            </template>
            <template #body="{ data }">
                <small class="text-xs white-space-nowrap" v-if="data.kyc && data.kyc.created_at">
                    {{ formatDate(data.kyc.created_at) }}
                </small>
            </template>
        </Column>

        <!-- KYC: обновлено -->
        <Column
            field="kyc.updated_at"
            sortable
            filterField="kyc.updated_at"
            dataType="date"
            :showFilterMatchModes="false"
            :showFilterOperator="false"
            :showClearButton="true"
        >
            <template #header>
                <span class="text-xs">KYC обновлено</span>
            </template>
            <template #filter="{ filterModel }">
                <Calendar
                    v-model="filterModel.value"
                    dateFormat="dd.mm.yy"
                    placeholder="dd.mm.yy"
                    mask="99.99.9999"
                />
            </template>
            <template #body="{ data }">
                <small class="text-xs white-space-nowrap" v-if="data.kyc && data.kyc.updated_at">
                    {{ formatDate(data.kyc.updated_at) }}
                </small>
            </template>
        </Column>

        <template #footer>
            <span class="text-sm">
                Всего {{ totalRecords }} отправителей.
            </span>
        </template>

    </DataTable>

    <!-- KYC Dialog -->
    <Dialog v-model:visible="kycDialogVisible" modal
        :header="kycDialogTitle"
        class="border-0"
        :breakpoints="{'960px': '75vw', '640px': '90vw'}"
        :style="{ width: '50vw' }"
        >
        <pre class="text-sm overflow-auto" style="max-height: 70vh; white-space: pre-wrap; word-break: break-word;">
            {{ kycDialogContent }}
        </pre>
        <template #footer>
            <Button label="Закрыть" @click="kycDialogVisible = false" severity="secondary" />
        </template>
    </Dialog>

    <!-- Dialog: изменение данных отправителя -->
    <Dialog
        v-model:visible="statusDialogVisible"
        modal header="Изменить данные отправителя"
        :breakpoints="{'960px': '75vw', '640px': '90vw'}"
        class="border-0"
        :style="{ width: '25rem' }"
    >
        <div class="flex flex-column gap-3">
            <div class="flex flex-column text-sm gap-2" v-if="currentSenderForStatus">
                <div class="flex">
                    <span class="font-semibold">ID отправителя:</span>
                    <span class="ml-1">{{ currentSenderForStatus.id }}</span>
                </div>
                <div v-if="currentSenderForStatus.email" class="flex">
                    <span class="font-semibold">Email:</span>
                    <span class="ml-1">{{ currentSenderForStatus.email }}</span>
                </div>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-sm">Новый статус</span>
                <Select
                    v-model="newSenderStatus"
                    :options="senderStatusOptions"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    placeholder="Выберите статус"
                >
                    <template #option="{ option }">
                        <Tag :severity="getSeverityByStatus(option.value)" :value="option.label" class="text-sm" />
                    </template>
                    <template #value="{ value }">
                        <Tag v-if="value" :severity="getSeverityByStatus(value)" :value="getStatusLabel(value)" class="text-sm" />
                    </template>
                </Select>
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-sm">Имя (first_name)</span>
                <InputText
                    v-model="editSenderFirstName"
                    class="w-full"
                    placeholder="Введите имя"
                />
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-sm">Фамилия (last_name)</span>
                <InputText
                    v-model="editSenderLastName"
                    class="w-full"
                    placeholder="Введите фамилию"
                />
            </div>
            <div class="flex flex-column gap-1">
                <span class="text-sm">Телефон</span>
                <InputText
                    v-model="editSenderPhone"
                    class="w-full"
                    placeholder="Введите телефон"
                />
            </div>
        </div>
        <template #footer>
            <Button label="Отмена" @click="statusDialogVisible = false" severity="secondary" :disabled="statusUpdating" />
            <Button
                label="Сохранить"
                icon="pi pi-check"
                class="ml-2 border-0"
                severity="success"
                :loading="statusUpdating"
                :disabled="statusUpdating"
                @click="updateSenderStatus"
            />
        </template>
    </Dialog>
    <Dialog header="file" class="border-0" modal
        v-model:visible="filePopup" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" >
        <img :src="fileUrl" class="w-full">
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api';

export default {
    name: 'SendersList',
    data() {
        return {
            list: [],
            filePopup: false,
            fileUrl: null,
            totalRecords: 0,
            loading: false,
            lazyParams: {},
            columns: [
                { field: 'utm', header: 'utm' },
                { field: 'tag', header: 'Теги' },
            ],
            selectedColumns: [],
            senderStatuses: ['created', 'approved', 'rejected', 'process'],
            kycLoadingId: null,
            kycDialogVisible: false,
            kycDialogTitle: '',
            kycDialogContent: '',
            statusDialogVisible: false,
            currentSenderForStatus: null,
            newSenderStatus: null,
            editSenderFirstName: '',
            editSenderLastName: '',
            editSenderPhone: '',
            statusUpdating: false,
            filters: {
                id: { value: '', matchMode: 'contains' },
                user_id: { value: '', matchMode: 'contains' },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
                email: { value: '', matchMode: 'contains' },
                first_name: { value: '', matchMode: 'contains' },
                last_name: { value: '', matchMode: 'contains' },
                phone: { value: '', matchMode: 'contains' },
                'kyc.type': { value: '', matchMode: 'contains' },
                'kyc.status': { value: '', matchMode: 'contains' },
                'kyc.doc_id': { value: '', matchMode: 'contains' },
                'kyc.last_message': { value: '', matchMode: 'contains' },
                'kyc.created_at': {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
                },
                'kyc.updated_at': {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
                },
            },
            sort: {
                field: 'kyc.created_at',
                order: -1
            },
        }
    },
    computed: {
        senderStatusOptions() {
            return this.senderStatuses.map((status) => ({
                label: this.getStatusLabel(status),
                value: status,
            }))
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        get_column(val) {
            for (const [k, v] of Object.entries(this.selectedColumns)) {
                if (v.field == val) return true
            }
        },
        get_short_id(value) {
            return this.helper.get_short_id(value)
        },
        copy(text) {
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        formatDate(value) {
            return this.helper.format_date(value)
        },
        getSeverityByStatus(status) {
            switch (status) {
                case 'approved':
                    return 'success'
                case 'rejected':
                    return 'danger'
                case 'process':
                    return 'warn'
                case 'created':
                    return 'info'
                default:
                    return 'secondary'
            }
        },
        getStatusLabel(status) {
            const label = this.helper.get_severity_status(status, 'ru')
            if(!label) return '-'
            return label.charAt(0).toUpperCase() + label.slice(1)
        },
        detail_page(id, page, new_tab = false) {
            if (new_tab) {
                const routeData = this.$router.resolve({ path: '/admin/' + page + '/' + id })
                window.open(routeData.href, '_blank')
            } else this.$router.push({ path: '/admin/' + page + '/' + id })
        },
        openPageWithParams(path, params) {
            const routeData = this.$router.resolve({ path, query: params })
            window.open(routeData.href, '_blank')
        },
        goToTelegram(username) {
            if (username) window.open('https://t.me/' + username, '_blank')
            return
        },
        openFilePopup(id) {
            if(!id) return
            this.filePopup = true
            this.getFile(id)
        },
        async getFile(id) {
            if(!id) return
            const file = await this.connect.get_file_by_id(id).then(res => res)
            console.log('file res', file)
            if (file) {
                const url = window.URL.createObjectURL(new Blob([file]))
                this.fileUrl = url
            } else {
                this.fileUrl = null
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Файл не найден', life: 3000 })
            }
        },
        onToggle(e) {
            if (e.length > 0) {
                this.selectedColumns = e
            } else {
                this.selectedColumns = []
            }
        },
        onPage(event) {
            this.lazyParams = event
            this.lazyParams.sort = this.sort
            this.LoadSenders()
        },
        onSort(event) {
            if (event.sortField && event.sortOrder) {
                this.sort = {
                    field: event.sortField,
                    order: event.sortOrder
                }
            } else {
                this.sort = {
                    field: 'kyc.created_at',
                    order: -1
                }
            }
            this.lazyParams.sort = this.sort
            this.LoadSenders()
        },
        onFilter() {
            this.lazyParams.filters = this.filters
            this.LoadSenders()
        },
        async LoadSenders() {
            this.loading = true
            try {
                window.scrollTo({ top: 0, behavior: 'smooth' })
                const res = await this.connect.AdminSendersList(
                    this.lazyParams.rows,
                    this.lazyParams.first,
                    this.lazyParams.filters,
                    this.lazyParams.sort
                ).then(res => res)
                if (!res.result || !res.data) {
                    if(res.message) {
                        this.showMess( 'error', 'Ошибка', res.message)
                    } else {
                        this.showMess( 'error', 'Ошибка', 'Ошибка загрузки отправителей')
                    }
                }
                this.list = res.data
                this.totalRecords = res.total
            } catch (e) {
                this.showMess( 'error', 'Ошибка', 'Ошибка запроса')
            }
            this.loading = false
        },
        openStatusDialog(sender) {
            if (!sender) return
            this.currentSenderForStatus = sender
            this.newSenderStatus = sender.status || null
            this.editSenderFirstName = sender.first_name || ''
            this.editSenderLastName = sender.last_name || ''
            this.editSenderPhone = sender.phone || ''
            this.statusDialogVisible = true
        },
        async updateSenderStatus() {
            if (!this.currentSenderForStatus || !this.currentSenderForStatus.id) return

            this.statusUpdating = true
            try {
                const dataToUpdate = {
                    status: this.newSenderStatus,
                    first_name: this.editSenderFirstName,
                    last_name: this.editSenderLastName,
                    phone: this.editSenderPhone,
                }

                const res = await this.connect.AdminSenderUpdateStatus(
                    this.currentSenderForStatus.id,
                    dataToUpdate
                ).then(r => r)

                if (!res || !res.result) {
                    this.showMess( 'error', 'Ошибка', (res && res.message) ? res.message : 'Ошибка обновления статуса')
                } else {
                    this.showMess( 'success', 'Успех', 'Данные отправителя обновлены')

                    // Обновим локально или перезагрузим список
                    this.LoadSenders()

                    this.statusDialogVisible = false
                }
            } catch (e) {
                this.showMess( 'error', 'Ошибка', 'Ошибка запроса')
            } finally {
                this.statusUpdating = false
            }
        },
        openKycDialog(type, value) {
            if (!value) return

            if (type === 'passport') {
                this.kycDialogTitle = 'KYC passport'
            } else if (type === 'metadata') {
                this.kycDialogTitle = 'KYC metadata'
            } else {
                this.kycDialogTitle = 'KYC'
            }

            if (typeof value === 'object') {
                try {
                    this.kycDialogContent = JSON.stringify(value, null, 2)
                } catch (e) {
                    this.kycDialogContent = String(value)
                }
            } else {
                this.kycDialogContent = String(value)
            }

            this.kycDialogVisible = true
        },
        resetFilter() {
            this.filters = {
                id: { value: '', matchMode: 'contains' },
                user_id: { value: '', matchMode: 'contains' },
                status: { value: null, matchMode: FilterMatchMode.EQUALS },
                email: { value: '', matchMode: 'contains' },
                first_name: { value: '', matchMode: 'contains' },
                last_name: { value: '', matchMode: 'contains' },
                phone: { value: '', matchMode: 'contains' },
                'kyc.type': { value: '', matchMode: 'contains' },
                'kyc.status': { value: '', matchMode: 'contains' },
                'kyc.doc_id': { value: '', matchMode: 'contains' },
                'kyc.last_message': { value: '', matchMode: 'contains' },
                'kyc.created_at': {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
                },
                'kyc.updated_at': {
                    operator: FilterOperator.AND,
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
                },
            }
            this.lazyParams = {
                first: 0,
                rows: 20,
                sortField: null,
                sortOrder: null,
                filters: this.filters,
                sort: this.sort,
            }
            this.LoadSenders()
        },
        async checkKyc(senderId) {
            if (!senderId) return
            this.kycLoadingId = senderId
            try {
                const res = await this.connect.AdminSendersCheckKyc(senderId).then(r => r)
                if (!res || !res.result) {
                    if(res.details && res.details.length > 0) {
                        for(const d of res.details) {
                            this.showMess('warn', 'Ошибка', d)
                        }
                    }
                    else if(res.message) this.showMess( 'error', 'Ошибка', res.message)
                    else this.showMess( 'error', 'Ошибка', (res && res.message) ? res.message : 'Ошибка проверки KYC')
                } else {
                    this.showMess( 'success', 'Успех', res.message || 'Проверка KYC выполнена')
                    // обновим данные отправителей после проверки
                    this.LoadSenders()
                }
            } catch (e) {
                this.showMess( 'error', 'Ошибка', 'Ошибка запроса')
            } finally {
                this.kycLoadingId = null
            }
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        const sender_id = (this.$route.query.id) ? this.$route.query.id : null
        if(sender_id) this.filters.id = {value: sender_id, matchMode: 'contains'}

        const user_id = (this.$route.query.user_id) ? this.$route.query.user_id : null
        if(user_id) this.filters.user_id = {value: user_id, matchMode: 'contains'}

        this.lazyParams = {
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
            sort: this.sort,
        }
        this.LoadSenders()
    }
}
</script>